import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules_FunctionWrapper, Button, LL_V_L, openContent } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_Home, PanelKey_SmartDocs } from '../../../_shared.js';
import { ICONS } from '@app/styles';
import './AdvisorMiniPanel_SmartDocs.scss';
import { Board_SmartDocs } from '../../../_enum/advisor-board/index.js';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Component_SmartDocs_Tabs } from '../../components/smart-docs/Component_SmartDocs_Tabs/Component_SmartDocs_Tabs.js';
import { advisorConfig_DevMode, ModuleFE_AdvisorSettings } from '../../../modules/ModuleFE_AdvisorSettings/index.js';
import { Component_SmartDocs } from '../../components/smart-docs/Component_SmartDocs/Component_SmartDocs.js';
import { AdvisorConfigKeyFE_SmartDocs_NoteIds, ModuleFE_Advisor_DiseaseProfile, ModuleFE_Advisor_Pathway, ModuleFE_Advisor_PathwayState, ModuleFE_Advisor_PathwayTransition, ModuleFE_EMInterface, ModuleFE_RuntimeProtocol, ModuleFE_RuntimeSmartNote } from '@app/advisor-frontend';
import { iconTooltipId } from '../../_style/icon-tooltip/index.js';
import { Debounce, exists, filterInstances } from '@nu-art/ts-common';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { ProtocolData } from '../../../_utils/ProtocolData/ProtocolData.js';
import { ProtocolStatus_AwaitingDispo } from '../../../_utils/ProtocolData/types.js';
import { ToastFilter_LiveMDM } from '../../components/smart-docs/toast.js';
import { ToasterPortal_BottomUp } from '@nu-art/toasting';
const headerModulesToAwait = [
    //Static Modules
    ModuleFE_Advisor_Pathway,
    ModuleFE_Advisor_PathwayState,
    ModuleFE_Advisor_PathwayTransition,
    ModuleFE_Advisor_DiseaseProfile,
    //Runtime Modules
    ModuleFE_RuntimeProtocol,
];
export class AdvisorMiniPanel_SmartDocs extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_SmartDocs,
        panelType: 'secondary',
    };
    updateMDMDebouncer = new Debounce(() => this.updateMDM(), 300);
    //######################### Life Cycle #########################
    __onRuntimeProtocolsUpdated = (...params) => {
        this.getMDMStatus.execute(exists(this.state.latestMDMTimestamp))
            .then(status => this.setState({ status }))
            .catch(err => this.logError(err));
    };
    __onRuntimeSmartNotesUpdated = (...params) => this.updateMDMDebouncer.trigger();
    __onReadOnlyChanged = () => this.forceUpdate();
    __onAdvisorSettingsUpdated = (key) => {
        if (key === advisorConfig_DevMode)
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        state.quickNoteMode ??= false;
        state.newMDMToView ??= false;
        state.latestMDMTimestamp = ModuleFE_RuntimeSmartNote.getLatestNote(AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm)?.__updated;
        state.status ??= 'no-mdm';
        return state;
    }
    componentDidMount() {
        this.getMDMStatus.execute(exists(this.state.latestMDMTimestamp))
            .then(status => this.setState({ status }))
            .catch(err => this.logError(err));
    }
    componentDidUpdate() {
        if (!this.state.focusedPanel) // @ts-ignore
            this.state.quickNoteMode = false;
        else if (this.state.newMDMToView) {
            // @ts-ignore
            this.state.newMDMToView = false;
            this.forceUpdate();
        }
    }
    //######################### Logic #########################
    getDispoProtocol() {
        const protocols = filterInstances(ModuleFE_RuntimeProtocol.cache.all().map(p => ProtocolData.createNew(p._id)));
        ProtocolData.sort(protocols);
        return protocols.find(p => p.getStatus() === ProtocolStatus_AwaitingDispo);
    }
    ;
    getMDMStatus = new AwaitModules_FunctionWrapper(headerModulesToAwait, (hasMDMTimestamp) => {
        const dispoProtocol = this.getDispoProtocol();
        const hasAdmit = !!dispoProtocol?.getAwaitingOrders().find(o => o.resourceType === 'admit');
        const hasDischarge = !!dispoProtocol?.getAwaitingOrders().find(o => o.resourceType === 'discharge');
        return hasAdmit
            ? 'admit'
            : hasDischarge
                ? 'discharge'
                : hasMDMTimestamp
                    ? 'general' : 'no-mdm';
    });
    getPanelClass() {
        return _className(super.getPanelClass(), Board_SmartDocs.isOpen() && 'open', this.state.newMDMToView && 'mdm-to-view', this.state.status);
    }
    openPanel_Impl = () => {
        ModuleFE_AdvisorAnalytics.trigger.view.view__liveMDM({ method: 'manual' });
        ModuleFE_AdvisorMini.openPanel(this.props.panelKey);
    };
    updateMDM = async () => {
        const latestMDM = ModuleFE_RuntimeSmartNote.getLatestNote(AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm);
        if (!latestMDM)
            return;
        if (!this.state.latestMDMTimestamp) //@ts-ignore
            return this.state.latestMDMTimestamp = latestMDM.__updated;
        if (latestMDM.__updated <= this.state.latestMDMTimestamp)
            return;
        //Disable mdm toast for now...
        // Toast_LiveMDM.toast('live-mdm', {
        // 	body: 'MDM has been updated',
        // });
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.setState({
                    latestMDMTimestamp: latestMDM.__updated,
                    newMDMToView: !this.state.focusedPanel
                }, () => resolve());
            }, 1800);
        });
    };
    // @ts-ignore
    getHeaderSubtitle = () => {
        switch (this.state.status) {
            case 'no-mdm':
                return 'MDM will be created as treatment advances';
            case 'general':
                return 'Auto generated dispo note';
            case 'discharge':
                return 'Discharge note ready';
            case 'admit':
                return 'Admission note ready';
            default:
                return '';
        }
    };
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        //30.4.2026 - For now we always return the general header, until management decides when to show the dispo header
        return this.render_GeneralHeader();
        // switch (this.state.status) {
        // 	case 'general':
        // 	case 'no-mdm':
        // 		return this.render_GeneralHeader();
        //
        // 	case 'admit':
        // 	case 'discharge':
        // 		return this.render_DispoHeader();
        // }
    };
    renderHeader_Tail = () => {
        if (ModuleFE_EMInterface.isReadonly() || ModuleFE_EMInterface.isPostDisposition())
            return;
        const dispo = this.state.status === 'admit' || this.state.status === 'discharge';
        return _jsxs(_Fragment, { children: [(this.state.focusedPanel || !dispo) &&
                    _jsx(ICONS.advisor_avn_addNote.component, { ...openContent.tooltip.top(iconTooltipId, 'Add note to MDM summary', { offset: 8 }), onClick: () => {
                            this.setState({ quickNoteMode: true });
                        } }), this.render_TailButton(), this.state.focusedPanel && _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                        ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
                    } })] });
    };
    render_GeneralHeader = () => {
        return _jsx(LL_V_L, { children: _jsx("div", { className: 'live-mdm__title', children: "Notes" }) });
    };
    render_TailButton = () => {
        if (this.state.focusedPanel)
            return;
        switch (this.state.status) {
            case 'admit':
            case 'discharge':
            // return <></>;
            case 'general':
            case 'no-mdm':
                return _jsx(Button, { variant: 'primary', onClick: this.openPanel_Impl, children: "View" });
        }
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        const devMode = ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_DevMode);
        if (devMode)
            return _jsx(Component_SmartDocs_Tabs, { scrollRef: scrollRef });
        return _jsx(Component_SmartDocs, { quickNoteMode: this.state.quickNoteMode, onCloseQuickNote: () => this.setState({ quickNoteMode: false }) });
    };
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
    //######################### Render - Extra Content #########################
    render_extraPanelContent = () => _jsx(ToasterPortal_BottomUp, { height: 100, bottomOffset: 8, modelFilter: ToastFilter_LiveMDM });
}
//# sourceMappingURL=AdvisorMiniPanel_SmartDocs.js.map